import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip } from '@mui/material'
import InfoIcon from '@mui/icons-material/ErrorOutlineOutlined'

import { ISignupExisitingAccount } from 'src/types'

import { useStyles } from './styles'

interface IProps {
  existingAccount: ISignupExisitingAccount
  children?: ReactNode
}

export const ExistingAccountTooltip = ({ existingAccount, children }: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()

  return (
    <Tooltip
      className={classes.infoWrapper}
      title={
        <ul className={classes.infoList}>
          <li>
            {t('accounts-table-account-name-column.v')}: {existingAccount?.account_holder || '-'}
          </li>
          <li>
            {t('account-form-website-input-label.v')}: {existingAccount?.website || '-'}
          </li>
          <li>
            {t('account-form-address-label.v')}: {existingAccount?.address || '-'}
          </li>
          <li>
            {t('table-country-column.v')}: {existingAccount?.country || '-'}
          </li>
          <li>
            {t('account-form-region-input-label.v')}: {existingAccount?.region || '-'}
          </li>
        </ul>
      }
    >
      <div>
        {children}
        <InfoIcon className={classes.infoIcon} />
      </div>
    </Tooltip>
  )
}
